<template>
  <div
    role="progressbar"
    class="tab-progress d-flex justify-content-center px-1 mb-5"
    v-if="preFilters.length > 1"
  >
    <button
      v-for="(item, index) in preFilters"
      :key="index"
      :class="[{ active: tabIndex === index }, 'btn tab-progress__btn']"
      @mousedown="preventFocus"
    >
      {{ index + 1 }}. {{ item.processBarName }}
      <span class="tab-progress__indicator"></span>
    </button>
  </div>

  <form
    class="d-flex"
    :style="[
      { width: preFilters.length * 100 + 'vw' },
      { transform: 'translateX(-' + tabIndex * 100 + 'vw)' },
    ]"
  >
    <fieldset
      v-for="(preFilter, index) in preFilters"
      :key="index"
      :class="[
        { active: tabIndex === index },
        { inactive: tabIndex !== index },
        ' text-center',
      ]"
    >
      <legend class="h1 mb-4 px-2">{{ preFilter.headline }}</legend>
      <div class="mb-4 px-2">
        Tilføj en eller flere af mulighederne nedenfor
      </div>
      <pre-filter-seasons
        :filters="preFilter.tags"
        @selectItem="selectItem"
        v-if="preFilter.viewType === 'Date'"
      />
      <pre-filter-swiper
        :filters="preFilter.tags"
        @selectItem="selectItem"
        v-else
      />
    </fieldset>
  </form>

      <div class="d-flex justify-content-center w-100">
        <button
          type="button"
          class="btn me-3"
          v-if="tabIndex > 0"
          @mousedown="preventFocus"
          @click="previousTabIndex()"
        >
          Tilbage
        </button>
        <button
          type="button"
          class="btn border rounded-pill"
          @mousedown="preventFocus"
          @click="nextTabIndex()"
          v-if="tabIndex < tabLength"
        >
          Næste
        </button>
        <button
          type="button"
          class="btn border rounded-pill"
          @mousedown="preventFocus"
          @click="showResults"
          v-if="tabIndex === tabLength"
        >
          Se resultat
        </button>
      </div>
</template>
<script>
import PreFilterSwiper from "./PreFilterSwiper.vue";
import PreFilterSeasons from "./PreFilterSeasons.vue";
export default {
  name: "PreFilterSearch",
  props: ["preFilters"],
  components: {
    PreFilterSwiper,
    PreFilterSeasons,
  },
  computed: {},
  data() {
    return {
      tabIndex: 0,
      tabLength: this.preFilters.length - 1,
    };
  },
  methods: {
    selectItem: function (tag) {
      this.$emit("selectItem", tag);
    },
    showResults: function () {
      this.$store.dispatch("showTripfinderResults");
    },
    nextTabIndex: function () {
      this.tabIndex++;
    },
    previousTabIndex: function () {
      this.tabIndex--;
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>